export const campaign = {
  field: {
    name: ' Judul',
    status: 'Status',
    max_attempts: 'Jumlah sudah maximum',
    attempts_interval_min: 'Waktu antara between attempts (min.)',
    calls_limit: 'Jumlah batasan calls',
    caller_id: 'Nomor penelepon',
    pbx_number: 'Nomor PBX Virtual',
    progress: 'Kemajuan',
    call_schedule: 'Jadwal panggilan',
    attempts: 'Upaya',
    dial_timeout: 'Waktu tunggu maksimum (sec.)',
    need_amd: 'Aktifkan pengenalan mesin penjawab'
  },

  deleted: 'dihapus',

  tooltips: {
    dial_timeout: 'Waktu tunggu maksimal bagi klien untuk menjawab panggilan',
    need_amd: 'Deteksi Mesin Penjawab - model yang memungkinkan Anda mengenali mesin penjawab dan keheningan'
  },

  table: {
    action: {
      show_detail_stat: 'Lihat statistics',
      create: 'Tambah Kampanye'
    }
  },

  filter: {
    status: {
      title: '@:autoinformer.campaign.field.status',
      active: 'Aktif',
      not_active: 'Tidak aktif',
      all: 'All'
    },

    name: {
      title: '@:autoinformer.campaign.field.name'
    },

    pbx_number: {
      title: '@:autoinformer.campaign.field.pbx_number'
    },

    caller_id: {
      title: '@:autoinformer.campaign.field.caller_id'
    }
  },

  modal: {
    remove: {
      content: 'Saudara yakin akan menghapus campaign <b>{name}<b>?'
    },

    change_status: {
      enable: 'Saudara yakin ingin memulai pemanggil prediktif?',
      disable: 'Saudara yakin ingin memberhentikan pemanggil prediktif?'
    },

    notice_pbx_module_required: {
      content:
        'Membuat pemanggil prediktif campaigns, aktivasi "<strong>the virtual PBX service</strong>"',
      ok: 'Hubungkan'
    },

    create_scheme: {
      title: 'Buat skema',
      option1: 'Pesan audio',
      option2: 'IVR',
      option3: 'Skema sendiri'
    },

    delete_scheme: 'Yakin ingin menghapus skema yang ada?'
  },

  create: {
    title: '@:autoinformer.breadcrumb.campaign.new'
  },

  edit: {
    title: '@:autoinformer.breadcrumb.campaign.edit'
  },

  tasks: {
    title: 'Tugas'
  },

  form: {
    title: 'Basic informasi',
    title_schedule: 'Jadwal panggilan',
    recipients_title: 'Penerima',
    save_btn: 'Simpan',
    update_btn: 'Perbaharui',
    calling_scheme: 'Skema panggilan',
    buttons: {
      create_scheme: 'Buat skema'
    }
  }
};
